module.exports = __webpack_public_path__ + "media/101.d1e45c4d.wav";